import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=c4b5c148"
import script from "./AppDrawer.vue?vue&type=script&lang=js"
export * from "./AppDrawer.vue?vue&type=script&lang=js"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=c4b5c148&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports